import React from "react";

import PerformanceStarDateFilter from "../../../shared-screens/views/shared/performanceStarDateFilter";

/** Manager performance star/date filter — shared filter with manager card layout. */
const FilterComponent = (props) => {
  return (
    <PerformanceStarDateFilter
      {...props}
      cardClassName="notification-form shadow card px-3 mb-3"
    />
  );
};

export default FilterComponent;
